import * as React from "react";
import { useState } from "react";
import Routes from "security-app/routing/Routes";
import { BootstrapModalConfirm, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { useArchiveInvestigation, useDeleteInvestigation } from "security-app/hooks/useInvestigationsAPI";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { MoreActionsMenu } from "components/common/MoreActions";
import useInvestigationPanel from "./hooks/useInvestigationPanel";
function InvestigationMoreActionsMenu({
  investigation,
  isArchived = false,
  onDelete: onDeleteProp = void 0,
  onArchive: onArchiveProp = void 0,
  onEdit: onEditProp = void 0
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { archiveInvestigation } = useArchiveInvestigation();
  const { deleteInvestigation } = useDeleteInvestigation();
  const { selectedInvestigationId, closeInvestigation } = useInvestigationPanel();
  const sendTelemetry = useSendTelemetry();
  const onArchive = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_ARCHIVED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    await archiveInvestigation({ invId: investigation.id, archive: true });
    if (typeof onArchiveProp === "function") {
      onArchiveProp(investigation.id);
    }
  };
  const onEdit = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_EDITED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    if (typeof onEditProp === "function") {
      onEditProp();
    }
  };
  const onRestore = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_RESTORED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    await archiveInvestigation({ invId: investigation.id, archive: false });
  };
  const onDelete = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.INVESTIGATION_DELETED, {
      app_pathname: "security",
      app_section: "investigation"
    });
    if (investigation.id === selectedInvestigationId) {
      closeInvestigation();
    }
    await deleteInvestigation({ invId: investigation.id });
    const currentInvestigationId = localStorage.getItem("currentInvestigationId");
    if (currentInvestigationId === investigation.id) localStorage.removeItem("currentInvestigationId");
    if (typeof onDeleteProp === "function") {
      onDeleteProp(investigation.id);
    }
    setShowDeleteModal(false);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActionsMenu, { title: "Toggle investigation actions" }, isArchived ? /* @__PURE__ */ React.createElement(MenuItem, { onClick: onRestore }, "Restore") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick: onArchive }, "Archive"), onEditProp ? /* @__PURE__ */ React.createElement(MenuItem, { onClick: onEdit }, "Edit") : /* @__PURE__ */ React.createElement(MenuItem, { onClick: onEdit, href: Routes.INVESTIGATIONS.details(investigation.id) }, "Edit"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onClick: () => setShowDeleteModal(true) }))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      title: "Are you sure you want to delete this investigation?",
      onConfirm: onDelete,
      onCancel: () => setShowDeleteModal(false),
      showModal: showDeleteModal
    },
    /* @__PURE__ */ React.createElement("div", null, "You are about to delete this investigation: ", investigation.name)
  ));
}
export default InvestigationMoreActionsMenu;
